import getTodoFolderById from '../selectors/getTodoFolderById';
export default function canCreateTaskInFolder(folderId: string | null): boolean {
    if (folderId) {
        const todoFolder = getTodoFolderById(folderId);
        return todoFolder && todoFolder.FolderType !== 'FlaggedEmails';
    }

    // You can always add in the default folder.
    return true;
}
